import "./styles.sass";
import { useLocation, useNavigate } from "react-router-dom";
import { useCallback, useEffect, useRef } from "react";
import { STORAGE_LANGUAGE_NAME } from "constants/variables";
import { useSelector } from "react-redux";
import * as authSelectors from "redux/auth/selectors";
import { useGetJWTSportsBookData } from "../../../queries/useGetJWTSportsBook";
import { Languages } from "../../../types/localization";
import { getEnv } from "../../../utils/hostname";

const IFRAME_PREFIX = "sportsbook";

const Gr8MiniIframe = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const isAuthenticated = useSelector(authSelectors.isAuthenticated);
  const navigate = useNavigate();
  const location = useLocation();

  const { data: JWTData, refetch } = useGetJWTSportsBookData();
  const userLanguage = localStorage.getItem(STORAGE_LANGUAGE_NAME) || "EN";
  const isStage =
    getEnv() === "stage" || getEnv() === "dev" || getEnv() === "local";
  const sportsBookHost = isStage
    ? "https://sport-iframe.pjdoi.xyz"
    : "https://sport-iframe.apcje.xyz";
  const buildSrc = (): string => {
    return isAuthenticated && JWTData?.token
      ? `${sportsBookHost}/${Languages[userLanguage]}/mini-iframe?jwt=${encodeURIComponent(JWTData?.token)}`
      : `${sportsBookHost}/${Languages[userLanguage]}/mini-iframe`;
  };
  const updateClientPath = useCallback(
    ({ path }: { path: string }) => {
      const lang = localStorage.getItem("lang") || "EN";
      const fullClientPath = `/${IFRAME_PREFIX}/${Languages[lang]}${path}`;
      if (location.pathname !== fullClientPath) {
        navigate(fullClientPath, { replace: true });
      }
    },
    [navigate, location.pathname],
  );

  const navigateToMainIFrame = useCallback(
    ({ data }: MessageEvent) => {
      if (
        data.type === "navigation" &&
        !!data?.path &&
        !data?.path?.includes("mini-iframe")
      ) {
        updateClientPath({ path: data.path });
      }
    },
    [updateClientPath],
  );

  useEffect(() => {
    if (isAuthenticated) {
      refetch();
    }
    window.addEventListener("message", navigateToMainIFrame);
    return () => {
      window.removeEventListener("message", navigateToMainIFrame);
    };
  }, [navigateToMainIFrame, isAuthenticated, refetch]);

  return (
    <div className="IFrameContainer">
      <iframe
        ref={iframeRef}
        src={buildSrc()}
        title="GR8 Mini Iframe"
        width="100%"
        height="100%"
        allowFullScreen
      />
    </div>
  );
};

export default Gr8MiniIframe;
